import { DataSnapshot } from 'firebase/database';

export default async function injectEntitiesIntoAnotherEntitiesByKey<Entity, InnerEntity>(
  entities: Entity[],
  keyOfKey: keyof Entity,
  keyOfInnerEntityInEntity: string,
  getInnerEnitiesMap: (
    uniqueKeys: (Entity[keyof Entity] | null)[],
    entities: Entity[],
  ) => Promise<(DataSnapshot | undefined)[]>,
) {
  const uniqueKeys = [...new Set(entities.map(entity => entity[keyOfKey] ?? null))];

  return await getInnerEnitiesMap(uniqueKeys, entities)
    .then(viewsResult => {
      return viewsResult.reduce(
        (obj, val) => ({ ...obj, [val?.key ?? '']: val?.val() }),
        {} as Record<string, InnerEntity>,
      );
    })
    .then(viewsMap => (entries: Entity[]) => {
      const ww = entries.map(entry => ({
        ...entry,
        [keyOfInnerEntityInEntity]: viewsMap?.[(entry[keyOfKey] as string) ?? ''] ?? null,
      }));
      return ww;
    });
}
